import styled from 'styled-components';
import {
  flexbox,
  justifyContent,
  alignItems,
  flexDirection
} from '../../styles/helpers/flexbox';
import ThemeHelper from '../../themes/theme-helper';

const Wrapper = styled.div((props) => {
  const { colours } = ThemeHelper.getTheme(props);

  return `
   ${flexbox()};

    position: relative;
    scrollbar-width: none;
    -ms-overflow-style: none;
    border-top: 1px solid ${colours.grey[400]};
    height: fit-content;

    &::-webkit-scrollbar {
      height: 0.05px !important;
      scrollbar-width: 0.05px !important;
    }

    &::-ms-scrollbar {
      height: 0.05px !important;
      scrollbar-width: 0.05px !important;
    }

    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
      margin-left: 5px;
    }
`;
});

const EmptyWrapper = styled.div((props) => {
  const { colours } = ThemeHelper.getTheme(props);

  return `
    width: 100%;
    height: 188px;
    position: relative;
    left: 260px;
    border-top: 1px solid ${colours.grey[400]};
    border-right: 1px solid ${colours.grey[400]};
`;
});

const LoaderContainer = styled.div`
  ${flexbox()};
  ${justifyContent('center')};
  ${alignItems('baseline')};

  flex: 1;
  margin-top: 200px;
  margin-left: 25%;
  position: fixed;
`;

const GridContainer = styled.div((props) => {
  const { colours } = ThemeHelper.getTheme(props);

  return `
        ${flexbox()};
        ${flexDirection('column')};

        width: 100%;
        height: fit-content;

        .cell {
            width: 82px;
            height: 40px;
            background: ${colours.grey[300]};
          }
    `;
});

export {
  Wrapper,
  EmptyWrapper,
  LoaderContainer,
  GridContainer
};
